module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAAMgAQMAAACK1tp+AAAABlBMVEXOESb///9W4q7JAAAA+ElEQVR42u3NAQkAAAgDsPcvrSmOIFuBJQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEDNXLLb7Xa73W632+12u91ut9vtdrvdbrfb7Xa73W632+12u91ut9vtdrvdbrfb7Xa73W632+12u91ut9vtdrvdbrfb7Xa73W632+12u91ut9vtdrvdbrfb7Xa73W632+12u91ut9vtdrvdbrfb7Xa73W632+12u91ut9vtdrvdbrfb7Xa73W632+12u91ut9vtdrvdbrfb7Xa73W632+12u91ut9vtdrvdbrfbf+8L2SSYD8KGrEAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mc.png
// module id = 1835
// module chunks = 0